import MainLayout from '@/layouts/MainLayout';
import { Helmet } from 'react-helmet';
import projektUnijnyImage from '@/assets/projekt-unijny.png';

const ProjektUnijny = () => {
  return (
    <MainLayout>
      <Helmet>
        <title>Projekt Unijny | Czułe klisze</title>
        <meta name="description" content="Informacje o projekcie unijnym - Europejski Fundusz Rolny na rzecz Rozwoju Obszarów Wiejskich" />
        <link rel="canonical" href="https://czuleklisze.pl/projekt-unijny" />
      </Helmet>
      
      <section className="pt-32 pb-20 bg-cream-50">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto">
            <img 
              src={projektUnijnyImage} 
              alt="Projekt Unijny - Europejski Fundusz Rolny na rzecz Rozwoju Obszarów Wiejskich" 
              className="w-full h-auto rounded-lg shadow-lg"
            />
          </div>
        </div>
      </section>
    </MainLayout>
  );
};

export default ProjektUnijny;
